import React, { useState, useLayoutEffect, useContext, useRef } from "react";
import LeftBar from "../../components/LeftBar";
import Header from "../../components/Header";
import Player from "../../components/Player";
import "./AppContainer.scss";
import ContentRouter from "./ContentRouter";
import { getUserId, hasPremium, isOwnerId, screenWidth } from '../../constants/function';
import { useSelector, useDispatch } from "react-redux";
import DirectChat from "../../components/DirectChat";
import { useEffect } from "react";
import NoInternet from "../../components/NoInternet";
import { SocketContext } from '../../context/socket';
import Streaming from "../Streaming/Streaming";
import { useHistory, useLocation } from "react-router-dom";
// import { leaveStream } from "../../action/stream";
import { clearSong } from "../../action/songs";
import Advertisement from "../../components/Advertisement";
import { updatecount } from "../../action/adv";
import emitter from '../../EventEmitter';
import SkDrawer from '../../components/SkDrawer/SkDrawer';
import OutsideClickHandler from 'react-outside-click-handler';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import BackToStream from '../../components/BackToStream/BackToStream';

import { act } from '../../constants/common';
import ErrorBoundary from '../../components/ErrorBoundary';
import { checkPremiumStatusAndRefresh } from '../../utils/refreshUserData';

function AppContainer(props) {
  // console.log("AppContainer rendering", props);
  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();
  const {
    isStream,
    streamData,
    title,
    goal,
    isNew,
    goalDescription,
    shareUrl,
    music,
    obs,
  } = useSelector((state) => state.stream);

  const [isOnline, setIsOnline] = useState(true);
  const [chatOpen, setChatOpen] = React.useState(false);
  const [isJoined, setIsJoined] = React.useState(false);
  const [tokenData, setTokenData] = React.useState({});
  const [songData, setSongData] = React.useState({});
  const [userDetail, setUserDetail] = React.useState({
    userName: null,
    userId: null,
    timeStamp: null,
    playlistroomId: null,
  });

  const isPremium = hasPremium();
  const [ currentScreenWidth, setCurrentScreenWidth ] = useState(screenWidth());
  const socket = useContext(SocketContext).Socket;

  const { showChat } = useSelector((state) => state.chat);
  const { track } = useSelector((state) => state.streamSong);
  const { count } = useSelector((state) => state.adv);
  const { index } = useSelector((state) => state.songs);
  const songs = useSelector((state) => state.songs);

  const currentSong = useRef(null);
  currentSong.current = songs["songs"].length > 0 ? songs["songs"][songs["index"]] : null;
  const currentSongs = useRef(0);
  currentSongs.current = songs["songs"].length;

  const [showAdv, setShowAdv] = React.useState(false);
  const [ isFullScreen, setIsFullScreen ] = React.useState(false);
  const [ isNavOpen, setIsNavOpen ] = useState(true);
  const [ isDrawerOpen, setIsDrawerOpen ] = useState(false);
  const [ isChatOpen, setIsChatOpen ] = React.useState(false);
  const [ currentSection, setCurrentSection ] = React.useState( "home" );

  useLayoutEffect(() => {
    function updateSize() {
      setCurrentScreenWidth( screenWidth() );
      setIsNavOpen( screenWidth() > 600 );  // NO_MAGIC
    }
    window.addEventListener("resize", updateSize);
    updateSize();
    return () => window.removeEventListener("resize", updateSize);
  }, []);

  const handleChatOpen = (e) => {
    setUserDetail({ userName: e.userName, userId: e.userid });
    setIsChatOpen(true);
  };

  React.useEffect(() => {
    emitter.on( act.GO_HOME, goHome );
    emitter.on( act.OPEN_FULL_SCREEN, openFullScreen );
    emitter.on( act.CLOSE_FULL_SCREEN, closeFullScreen );
    emitter.on( act.OPEN_DRAWER, openDrawer );
    emitter.on( act.CLOSE_DRAWER, closeDrawer );
    emitter.on( act.TOGGLE_DRAWER, toggleDrawer );

    return () => {
      if ( emitter ) { // TODO: get working
        // emitter.off('goHome', goHome);
        // emitter.off('openFullScreen', openFullScreen);
        // emitter.off('closeFullScreen', closeFullScreen);
        // emitter.off('openDrawer', openDrawer);
        // emitter.off('closeDrawer', closeDrawer);
        // emitter.off('toggleDrawer', toggleDrawer);
      }
    }
  },[]);

  React.useEffect(() => {
    setIsOnline(window.navigator.onLine);

    window.addEventListener("online", () => {
      setIsOnline(true);
      // if (isStream) window.location.reload();
    });

    window.addEventListener("offline", () => {
      setIsOnline(false);
      if (isStream) {
        // dispatch(leaveStream());
        history.push("/app/Home");
      }
    });
  },[]);

  useEffect(() => {
    if (!showChat) setIsChatOpen(false);
  }, [showChat]);

  useEffect(() => {
    if (isStream) {
      setIsChatOpen(false);
      if (songs["songs"].length > 0) {
        songs["songs"][index].track.pause();
        dispatch(clearSong());
      }
    }
  }, [isStream]);

  useEffect(() => {
    if (socket)
      socket.on("show-ad", (data) => {
        if (!isPremium) {
          const userId = getUserId();
          if (data.indexOf(userId) >= 0 && !count && !isStream) {
            if (!count && currentSong.current && currentSong.current.track) {
              currentSong.current.track.pause();
            }
            dispatch(updatecount(1));
          } else if (isStream && data.indexOf(userId) >= 0 && !count) {
            dispatch(updatecount(1));
          }
        }
      });
  }, [socket, songs]);

  useEffect(() => {
    setShowAdv(count ? true : false);
    if (
      !isStream &&
      !count &&
      currentSong.current &&
      currentSong.current.track &&
      currentSongs.current > 1
    ) {
      // currentSong.current.track.play();
    }
    else if (isStream && track && !count) {
      track.resumeProcessAudioBuffer();
      track.setVolume(10);
    }
  }, [count]);

  useEffect(() => {
    if (isStream && track && count) {
      track.pauseProcessAudioBuffer();
      track.setVolume(0);
    }
  }, [track]);

  // Check for premium status changes (for mobile subscriptions)
  useEffect(() => {
    // Check on mount and when window regains focus
    checkPremiumStatusAndRefresh();

    const handleFocus = () => {
      checkPremiumStatusAndRefresh();
    };

    window.addEventListener('focus', handleFocus);

    // Also check periodically every 10 minutes while app is active
    const intervalId = setInterval(() => {
      checkPremiumStatusAndRefresh();
    }, 10 * 60 * 1000); // 10 minutes

    return () => {
      window.removeEventListener('focus', handleFocus);
      clearInterval(intervalId);
    };
  }, []);


  const goHome = async () => {
    emitter.emit( act.HIDE_STREAM );
    closeDrawer();
    history.push("/app/Home");
  }

  const goUpload = async () => {
    emitter.emit( "hideStream" );
    closeDrawer();
    history.push("/app/UploadMusic");
  }

  const openFullScreen = async () => {
    if (!document.fullscreenElement && !document.webkitFullscreenElement) {
      let elem = document.getElementById("outerBox");
      if (elem) {
        try {
          if (elem.requestFullscreen) {
            await elem.requestFullscreen();
          } else if (elem.webkitRequestFullscreen) {
            await elem.webkitRequestFullscreen();
          } else if (elem.webkitEnterFullscreen) {
            await elem.webkitEnterFullscreen();
          }
          setIsFullScreen(true);
        }
        catch(e) {
          console.log(e);  // TIER_LOG
        }
      }
    }
  }

  const closeFullScreen = async () => {
    if (document.fullscreenElement || document.webkitFullscreenElement) {
      try {
        if (document.exitFullscreen) {
          await document.exitFullscreen();
        } else if (document.webkitExitFullscreen) {
          await document.webkitExitFullscreen();
        } else if (document.webkitCancelFullScreen) {
          await document.webkitCancelFullScreen();
        }
        setIsFullScreen(false);
      }
      catch(e) {
          console.log(e); // TIER_LOG
      }
    }
  }

  const openDrawer = () => {
    setIsDrawerOpen( true );
  };

  const closeDrawer = () => {
    setIsDrawerOpen( false );
  };

  const toggleDrawer = () => {
    setIsDrawerOpen( !isDrawerOpen );
  };

  const switchSection = (section) => {
    if ( section === "home" ) { goHome(); return; }
    if ( section === "upload" ) { goUpload(); return; }

      if ( isDrawerOpen && currentSection === section ) {
          closeDrawer();
      } else {
          if ( !isDrawerOpen ) openDrawer();
          history.push("/app/" + section);
          setCurrentSection(section);
      }
  }

  return (
    <>
      {isOnline ? (
        <div id="outerBox">

          {/* Hide main header when in streaming view */}
          {!location.pathname.includes('/LiveVideoStreaming') && (
            <Header
                currentScreenWidth={currentScreenWidth}
                isJoined={isJoined}
                tokenData={tokenData}
                songData={songData}
                toggleNav={() => setIsNavOpen(!isNavOpen)}
                isChatOpen={isChatOpen}
                setIsChatOpen={(e) => { typeof e === "object" ? handleChatOpen(e) : setIsChatOpen(true) }} // WTF
                isFullScreen={isFullScreen}
            />
          )}

 <div id="contentBox" className={`flex w-full ${location.pathname.includes('/LiveVideoStreaming') ? '' : 'pt-[60px]'}`}>
  {/* Only show LeftBar when NOT streaming */}
  {!isStream && (
    <LeftBar
      isNavOpen={isNavOpen}
      toggleNavOpen={(e) => { screenWidth() < 600 ? setIsNavOpen(e) : setIsNavOpen(true) } }
      switchSection={ switchSection }
    />
  )}

  { isDrawerOpen &&
      <OutsideClickHandler onOutsideClick={() => switchSection( "home" ) }>
        <SkDrawer {...props} />
      </OutsideClickHandler>
  }

  {!isStream && (
    <div 
      className="p-5"
      style={{
        // Only add margin when LeftBar is visible (not streaming)
        marginLeft: (isNavOpen) ? "210px" : "0px", 
        width: (isNavOpen) ? "calc(100vw - 210px)" : "100vw", 
        transition: "margin-left 0.3s ease, width 0.3s ease",
      }}
    >
      <ErrorBoundary>
        <ContentRouter {...props} />
      </ErrorBoundary>
    </div>
  )}

          </div>

          {!isStream && songs && songs["songs"].length > 0 ? ( // TODO: better state variables
            <Player
              songIndex={songs["index"]}
              prevSongIndex={songs["prevIndex"]}
              songs={songs["songs"]}
              all={songs["all"]}
              showAdv={showAdv}
            />
          ) : null}

          {isChatOpen ? (
            <DirectChat
              title={userDetail["userName"]}
              senderUserId={userDetail["userId"]}
              timeStamp={userDetail["timeStamp"]}
              playlistroomId={userDetail["playlistroomId"]}
              senndUserId={(userName, userId, timeStamp, playlistroomId) =>
                setUserDetail({
                  userName: userName,
                  userId: userId,
                  timeStamp: timeStamp,
                  playlistroomId: playlistroomId,
                })
              }
              onOutsideClick={() => {
                setUserDetail({ userName: null, userId: null });
                setIsChatOpen(false);
              }}
            />
          ) : null}

          {showAdv && !isPremium ? <Advertisement /> : null}

          {/* Streaming Overlay - Moved outside content flow */}
          {isStream ? (
            <Streaming
              streamData={streamData}
              title={title}
              goal={goal}
              isNew={isNew}
              goalDescription={goalDescription}
              shareUrl={shareUrl}
              music={music}
              isJoined={isJoined}
              setIsJoined={setIsJoined}
              tokenData={tokenData}
              setTokenData={setTokenData}
              songData={songData}
              setSongData={setSongData}
              obs={obs}
            />
          ) : null}

          {/* Add ToastContainer here */}
          <ToastContainer
            position="bottom-right"
            autoClose={3000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme="dark"
          />
          
          {/* Back to Stream Button */}
          <BackToStream />
        </div>
      ) : (
        <NoInternet
          open={!isOnline}
          onRefresh={() => setIsOnline(window.navigator.onLine)}
        />
      )}
    </>
  );
}

export default AppContainer;
